import { render, staticRenderFns } from "./SearcherMaterialCategoriesWithDescendants.vue?vue&type=template&id=a734d568&scoped=true&"
import script from "./SearcherMaterialCategoriesWithDescendants.vue?vue&type=script&lang=js&"
export * from "./SearcherMaterialCategoriesWithDescendants.vue?vue&type=script&lang=js&"
import style0 from "./SearcherMaterialCategoriesWithDescendants.vue?vue&type=style&index=0&id=a734d568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734d568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAutocomplete,VIcon,VMenu,VSheet,VTreeview})
